import quickFetch, { type AjaxOptions } from 'quick-fetch';

export const promisifyEarlyRequest = <TResult>(args: AjaxOptions) => {
  const name = crypto.randomUUID();

  quickFetch.makeEarlyRequest(name, args);

  const request = quickFetch.getRequestStateByName(name);

  if (!request) {
    throw new Error(`Early request not found: ${name}`);
  }

  return new Promise<TResult>((resolve, reject) => {
    request.whenFinished((result) => {
      args.whenFinished?.(result);
      resolve(result);
      quickFetch.removeEarlyRequest(name);
    });

    request.onError((xhr, message) => {
      args.onError?.(xhr, message);
      reject(new Error(`Early request failed: ${message}`));
      quickFetch.removeEarlyRequest(name);
    });
  });
};
